import React, { useEffect } from "react";
import styles from "./EvaluationFundAllocation.module.scss";
import {
  Box,
  TextField,
  Typography,
  Button,
  MenuItem,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Container,
  Divider,
} from "@mui/material";
import { useFormik, FieldArray, FormikProvider, getIn } from "formik";
import { FundAllocationValues } from "../../../types/types";
import { FundAllocationSchema } from "../../../forms/FundAllocationValidation";
import { InitialValuesFundAllocation } from "../../../types/formTypes";
import { FrequenciesFunds } from "../../../data/alldata";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { addFundallowItem } from "../../../redux/actions/Actions";
import { useNavigate } from "react-router-dom";

const EvaluationFundAllocation = () => {
  const applicationManageArr = useSelector(
    (state: RootState) => state.app.applicationManageData
  );
  const applicationDetails = useSelector(
    (state: RootState) => state.app.fundAllocationDetails
  );
  const fundallocationData = useSelector(
    (state: RootState) => state.app.fundAllocation
  );
  console.log("fundallocationData", fundallocationData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: InitialValuesFundAllocation,
    validationSchema: FundAllocationSchema,
    onSubmit: (values) => {
      console.log("Submitted:", values);
      dispatch(addFundallowItem(values as FundAllocationValues) as any);
      navigate(-1);
    },
  });
  const handleFieldChange = (
    index: number,
    field: "allocationAmount" | "installments",
    value: string
  ) => {
    const parsedValue = parseInt(value) || 0;

    const current = formik.values.funds[index];
    const updated = {
      ...current,
      [field]: parsedValue,
    };

    const allocation =
      field === "allocationAmount" ? parsedValue : current.allocationAmount;
    const installments =
      field === "installments" ? parsedValue : current.installments;

    const calculatedTotal = Number(allocation) * Number(installments);

    formik.setFieldValue(`funds[${index}].${field}`, parsedValue);
    formik.setFieldValue(`funds[${index}].totalAmount`, calculatedTotal);
  };
  const grandTotal = formik.values.funds.reduce(
    (acc, row) => acc + (Number(row.totalAmount) || 0),
    0
  );
  const formatToMMDDYYYY = (isoDate: string): string => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return ""; // invalid date

    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  };
  const convertToISOString = (rawDate: string): string => {
    const year = rawDate?.slice(0, 4);
    const month = rawDate?.slice(4, 6);
    const day = rawDate?.slice(6, 8);

    const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
    return date.toISOString(); // Output: 2025-06-13T00:00:00.000Z
  };
  useEffect(() => {
    if (applicationManageArr[0]?.status === "approved") {
      formik.setFieldValue(
        `startDate`,
        formatToMMDDYYYY(applicationDetails[0]?.scholarship_start_dt)
      );
      formik.setFieldValue(
        `endDate`,
        formatToMMDDYYYY(applicationDetails[0]?.scholarship_end_dt)
      );

      applicationDetails[0]?.fund_allocation.map((item, index) => {
        return (
          formik.setFieldValue(`funds.[${index}].purpose`, item.purpose),
          formik.setFieldValue(
            `funds.[${index}].allocationAmount`,
            item.allocation_amount
          ),
          formik.setFieldValue(`funds.[${index}].frequency`, item.frequency),
          formik.setFieldValue(
            `funds.[${index}].installments`,
            item.no_of_installment
          ),
          formik.setFieldValue(`funds.[${index}].totalAmount`, item.total_amt)
        );
      });
    } else {
      const startDate = String(fundallocationData[0]?.startDate ?? "");
      if (startDate.includes("T")) {
        formik.setFieldValue(
          `startDate`,
          formatToMMDDYYYY(fundallocationData[0]?.startDate as any)
        );
        formik.setFieldValue(
          `endDate`,
          formatToMMDDYYYY(fundallocationData[0]?.endDate as any)
        );
      } else if (startDate.length === 8) {
        formik.setFieldValue(
          `startDate`,
          convertToISOString(fundallocationData[0]?.startDate as any)
        );
        formik.setFieldValue(
          `endDate`,
          convertToISOString(fundallocationData[0]?.endDate as any)
        );
      } else {
        formik.setFieldValue(
          `startDate`,
          fundallocationData[0]?.startDate as any
        );
        formik.setFieldValue(`endDate`, fundallocationData[0]?.endDate as any);
      }

      fundallocationData[0]?.funds.map((item, index) => {
        return (
          formik.setFieldValue(`funds.[${index}].purpose`, item.purpose),
          formik.setFieldValue(
            `funds.[${index}].allocationAmount`,
            item.allocationAmount
          ),
          formik.setFieldValue(`funds.[${index}].frequency`, item.frequency),
          formik.setFieldValue(
            `funds.[${index}].installments`,
            item.installments
          ),
          formik.setFieldValue(`funds.[${index}].totalAmount`, item.totalAmount)
        );
      });
    }
  }, []);

  return (
    <>
      <Container className={styles.container}>
        <Box className={styles.header}>
          <Typography variant="h5" className={styles.title}>
            Fund Allocation Details
          </Typography>
          {/* <Box className={styles.navigationButtons}>
            <Button
              variant="contained"
              className={styles.saveButton}
              onClick={() => formik.handleSubmit()}
            >
              Submit
            </Button>
          </Box> */}
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          paddingBottom={2}
        >
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Student Name: </Typography>
            <Typography fontWeight={"bold"}>
              {applicationManageArr[0]?.name}
            </Typography>
          </Box>
          {/* <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Scholarship ID: </Typography>
            <Typography fontWeight={"bold"}>SRBF2022/01</Typography>
          </Box> */}
        </Box>
        <Divider sx={{ marginBottom: 3 }} />
        <form onSubmit={formik.handleSubmit} className="form-group">
          <Box className={styles.educationSection}>
            {/* {(applicationDetails[0]?.first_payment_amt === undefined || applicationDetails[0]?.first_payment_dt === undefined) && (
              <Box
                className={`${styles.fieldRow} ${styles.fieldRowOth}`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label="First Payment Date *"
                      views={["year", "month", "day"]}
                      value={
                        formik.values.firstpaymentdate
                          ? dayjs(
                              formik.values.firstpaymentdate,
                              "YYYYMMDD"
                            )
                          : null
                      }
 
                      onChange={(date) => {
                      formik.setFieldValue(
                        "firstpaymentdate",
                        date && date.isValid() ? date.format("YYYYMMDD") : ""
                      );
                    }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error:
                            (formik.touched?.firstpaymentdate ||
                              formik.submitCount > 0) &&
                            typeof formik.errors !== "string" &&
                            Boolean(
                              (formik.errors as any)?.firstpaymentdate
                            ),
                          helperText:
                            (formik.touched?.firstpaymentdate ||
                              formik.submitCount > 0) &&
                            typeof formik.errors !== "string" &&
                            (formik.errors as any)?.firstpaymentdate,
                          InputLabelProps: { shrink: true },
                          className: styles.textFourField,
                        },
                      }}
                        
                    />
                  </DemoContainer>
                </LocalizationProvider>
                                  
              
                <TextField
                  
                  id="firstpayment"
                  name="firstpayment"
                  label="First Payment"
                  type="number"
                  value={formik.values.firstpayment ?? ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.firstpayment && Boolean(formik.errors.firstpayment)
                  }
                  helperText={formik.touched.firstpayment && formik.errors.firstpayment}
                  className={styles.textNoneField}
                />
                
              </Box>
            )} */}
            <Box className={styles.fieldRow}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Scholarship Start Date *"
                    views={["year", "month", "day"]}
                    format="DD/MM/YYYY"
                    value={
                      formik.values.startDate
                        ? dayjs(formik.values.startDate, "YYYYMMDD")
                        : null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        "startDate",
                        date && date.isValid() ? date.format("YYYYMMDD") : ""
                      );
                      // Optional: Reset endDate if it's earlier than new startDate
                      if (
                        date &&
                        date.isValid() &&
                        formik.values.endDate &&
                        dayjs(formik.values.endDate, "YYYYMMDD").isBefore(date)
                      ) {
                        formik.setFieldValue("endDate", "");
                      }
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error:
                          formik.touched.startDate &&
                          Boolean(formik.errors.startDate),
                        helperText: formik.touched.startDate
                          ? formik.errors.startDate
                          : "",
                        InputLabelProps: { shrink: true },
                        className: styles.textFourField,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Scholarship End Date *"
                    views={["year", "month", "day"]}
                    format="DD/MM/YYYY"
                    minDate={
                      formik.values.startDate
                        ? dayjs(formik.values.startDate, "YYYYMMDD")
                        : undefined
                    }
                    value={
                      formik.values.endDate
                        ? dayjs(formik.values.endDate, "YYYYMMDD")
                        : null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        "endDate",
                        date && date.isValid() ? date.format("YYYYMMDD") : ""
                      );
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error:
                          formik.touched.endDate &&
                          Boolean(formik.errors.endDate),
                        helperText: formik.touched.endDate
                          ? formik.errors.endDate
                          : "",
                        InputLabelProps: { shrink: true },
                        className: styles.textFourField,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>

            <FormikProvider value={formik}>
              <FieldArray name="funds">
                {({ push, remove }) => (
                  <Box>
                    {formik.values.funds.map((fundItem, index) => (
                      <Accordion
                        key={index}
                        defaultExpanded
                        className={styles.accordion}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            variant="subtitle1"
                            className="accrodionHeading"
                          >
                            {/* Fund {index + 1} */}
                            {fundItem.purpose
                              ? fundItem.purpose
                              : `Fund ${index + 1}`}{" "}
                            {fundItem.totalAmount &&
                              `-₹ ${fundItem.totalAmount}`}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box
                            className={`${styles.fieldRow} ${styles.fieldRowOth} ${styles.fundAllocationBox}`}
                          >
                            <TextField
                              fullWidth
                              id={`funds[${index}].purpose`}
                              name={`funds[${index}].purpose`}
                              label="Purpose *"
                              value={fundItem.purpose}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.purpose &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)?.purpose
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.purpose &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)?.purpose
                              }
                              className={styles.textFourField}
                            />

                            <TextField
                              fullWidth
                              id={`funds[${index}].allocationAmount`}
                              name={`funds[${index}].allocationAmount`}
                              label="Allocation Amount *"
                              value={fundItem.allocationAmount}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "allocationAmount",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]
                                  ?.allocationAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.allocationAmount
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]
                                  ?.allocationAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)
                                  ?.allocationAmount
                              }
                              className={styles.textFourField}
                            />

                            <TextField
                              fullWidth
                              id={`funds[${index}].frequency`}
                              name={`funds[${index}].frequency`}
                              label="Frequency *"
                              select
                              value={fundItem.frequency}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.frequency &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.frequency
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.frequency &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)?.frequency
                              }
                              className={styles.textFourField}
                            >
                              <MenuItem value="">Select Frequency</MenuItem>
                              {FrequenciesFunds.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </TextField>
                            <TextField
                              fullWidth
                              id={`funds[${index}].installments`}
                              name={`funds[${index}].installments`}
                              label="No of Installments *"
                              value={fundItem.installments}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "installments",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.installments &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.installments
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.installments &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)
                                  ?.installments
                              }
                              className={styles.textFourField}
                            />

                            <TextField
                              fullWidth
                              id={`funds[${index}].totalAmount`}
                              name={`funds[${index}].totalAmount`}
                              label="Total Amount *"
                              value={fundItem.totalAmount}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.totalAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.totalAmount
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.totalAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)
                                  ?.totalAmount
                              }
                              className={styles.textFourField}
                            />
                          </Box>

                          {formik.values.funds.length > 1 && (
                            <Button
                              startIcon={<RemoveCircleOutlineIcon />}
                              color="error"
                              onClick={() => remove(index)}
                              className={styles.removeButton}
                            >
                              Remove
                            </Button>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    ))}
                    <Box
                      padding={2}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <Button
                        startIcon={<AddCircleOutlineIcon />}
                        variant="contained"
                        onClick={() =>
                          push({
                            purpose: "",
                            allocationAmount: "",
                            frequency: "",
                            installments: "",
                            totalAmount: "",
                          })
                        }
                        className={styles.commonBtn}
                      >
                        Add More Fund
                      </Button>
                    </Box>
                    {formik.touched.funds &&
                      typeof formik.errors.funds === "string" && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{ mt: 1 }}
                        >
                          {formik.errors.funds}
                        </Typography>
                      )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        </form>
        <Box>
          <Typography variant="h6">
            Grand Total: ₹ <strong>{grandTotal}</strong>
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          className={styles.btnsPanel}
        >
          <Button
            variant="contained"
            className={styles.backButton}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            className={styles.saveButton}
            onClick={() => formik.handleSubmit()}
            disabled={applicationManageArr[0]?.status === "approved"}
          >
            Save
          </Button>
        </Box>
      </Container>
    </>
  );
};
export default EvaluationFundAllocation;
